<template>
  <div
    class="market-contract-list-v2-embed"
    :class="{ 'market-contract-list-v2-embed--narrow': isNarrowContainer }"
    @click.capture="captureTrigger"
  >
    <market-contracts-list-header-sushi
      :market="displayMarket"
      :forCmsWidget="true"
      :force-mobile-layout="isNarrowContainer"
    ></market-contracts-list-header-sushi>
    <div class="market-contract-list-v2-embed__contracts" :data-newtab="openNewTab.toString()">
      <div
        class="market-contract-list-v2-embed__contract"
        :class="{
          'market-contract-list-v2-embed__contract--last': index === market.contracts.length - 1,
        }"
        v-for="(contract, index) in displayMarket.contracts.filter((item) =>
          market.contracts.some((selected) => selected.contractId === item.contractId),
        )"
        :key="contract.contractId"
      >
        <market-contract-horizontal-sushi
          v-if="isLayoutDesktop && !isNarrowContainer"
          @contractClicked="onContractClick"
          :data-contract-id="contract.contractId"
          :market="displayMarket"
          :contract="contract"
          :forCmsWidget="true"
          :cms-trade-disabled="isCmsTradeDisabled(contract)"
        ></market-contract-horizontal-sushi>
        <market-contract-horizontal-sushi-mobile
          v-else
          @contractClicked="onContractClick"
          :data-contract-id="contract.contractId"
          :market="displayMarket"
          :contract="contract"
          :forCmsWidget="true"
          :cms-trade-disabled="isCmsTradeDisabled(contract)"
        ></market-contract-horizontal-sushi-mobile>
        <div
          v-if="index !== market.contracts.length - 1"
          class="market-contract-list-v2-embed__contract-line"
        ></div>
      </div>
    </div>
  </div>
</template>

<script src="./market-contract-list-v2-embed.js"></script>
<style src="./market-contract-list-v2-embed.scss" lang="scss"></style>
